module.exports = __webpack_public_path__ + "static/media/Login-Page-Grapic.42e60d48.png";